module.exports = __webpack_public_path__ + "static/media/image-card-2.5c9683d1.png";